module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xabdo3-a174ca66ec550ddc984dc42975b766cf.jpg";